export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            了解更多关于韩国漫画网的故事与使命
          </p>
        </div>

        <div className="max-w-[860px] mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start">
              <div className="w-full md:w-[280px] flex-shrink-0">
                <div className="w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cozy%20modern%20reading%20space%20with%20tablet%20displaying%20colorful%20Korean%20webtoon%20art%2C%20warm%20ambient%20lighting%2C%20bookshelves%20in%20background%2C%20clean%20aesthetic%2C%20editorial%20quality%20photography%2C%20soft%20coral%20and%20cream%20tones&width=800&height=600&seq=about-kr-comics&orientation=landscape"
                    alt="韩国漫画网 - 关于我们"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="flex-1">
                <p className="text-base text-foreground-800 leading-relaxed mb-4">
                  韩国漫画网成立于2023年，是国内领先的韩国漫画资源聚合平台。我们致力于为广大韩漫爱好者打造一个便捷、全面的韩国漫画网站大全入口，让每一位读者都能轻松找到心仪的韩漫作品。
                </p>
                <p className="text-base text-foreground-800 leading-relaxed mb-4">
                  平台目前已收录超过12,000部韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑、校园、穿越、都市、古风等全品类。所有漫画均支持下拉式阅读模式，完美适配手机和电脑端，让阅读体验更加流畅舒适。
                </p>
                <p className="text-base text-foreground-800 leading-relaxed mb-6">
                  我们坚持每日更新，实时同步热门漫画的最新章节，确保读者不错过任何精彩内容。同时，我们持续优化分类索引和推荐算法，帮助用户在海量韩漫中快速发现感兴趣的作品。
                </p>
                <div className="flex flex-wrap items-center gap-6 text-sm">
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    <span className="text-foreground-700">12,000+ 韩漫资源</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    <span className="text-foreground-700">每日实时更新</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    <span className="text-foreground-700">全品类覆盖</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}